import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext(null);

export const translations = {
  it: {
    nav: { prodotti: "Prodotti", marchi: "Marchi", esperienza: "Esperienza", canali: "Canali", gruppi: "Gruppi d'Acquisto", cta: "Richiedi Preventivo" },
    hero: {
      label: "Importatore & Distributore B2B",
      lines: ["VENDITA E", "DISTRIBUZIONE", "DI PELLET IN LEGNO"],
      subtitle: "Fornitura di pellet certificato a rivenditori, GDO e gruppi d'acquisto in tutta Italia. Sacchetti, big bag, sfuso e camion completi — direttamente dalla produzione. Pellet ideale per stufe, caminetti e caldaie a pellet.",
      cta: "Richiedi Preventivo",
      badge: "Qualità certificata",
      stats: [["15 kg", "Sacchetti bancalati"], ["1 t", "Big Bag"], ["Sfuso", "Consegna alla rinfusa"], ["Full truck", "Camion completi"]],
    },
    marquee: ["TUpellet — Conifera Spagnola", "Fuoco nel Fuoco Gold — Faggio & Abete", "Fuoco nel Fuoco Platin — Abete Puro"],
    products: {
      label: "Formati di fornitura",
      titleA: "Come ", titleB: "consegniamo",
      intro: "Ogni formato è pensato per un canale specifico: dal rivenditore con negozio al grande gruppo d'acquisto.",
      cards: [
        { tag: "Rivenditori", title: "Sacchetti 15 kg", desc: "Sacchi da 15 kg su bancali, sigillati e pronti per la distribuzione al dettaglio. Composizione bancale dedicata per ciascun marchio." },
        { tag: "Rivenditori", title: "Big Bag 1 t", desc: "Sacconi da una tonnellata, ideali per stoccaggio e movimentazione rapida con muletto." },
        { tag: "Rivenditori", title: "Alla Rinfusa", desc: "Pellet sfuso consegnato con autobotte, per chi dispone di silos e sistemi di stoccaggio." },
        { tag: "Gruppi d'acquisto & GDO", title: "Camion Completi", desc: "Solo carichi completi (full truck). Non forniamo bancali di pellet sciolto: massima efficienza logistica e prezzo dedicato ai gruppi d'acquisto." },
      ],
    },
    brands: {
      label: "I marchi che distribuiamo",
      titleA: "Tre marchi.", titleB: "Una sola qualità.",
      cert: "Tutti i nostri pellet sono certificati ENplus A1",
      specLabels: ["sacchetti / bancale", "bancali / bilico", "peso camion"],
      items: [
        { variant: "Conifera Spagnola", desc: "Pellet 100% conifera di origine spagnola. Alto potere calorifico e combustione costante, con un rapporto qualità/prezzo davvero ottimo: la scelta ideale per chi cerca resa e convenienza.", tags: ["ENplus A1", "Conifera", "Qualità/prezzo"] },
        { variant: "Faggio & Abete", desc: "Miscela di faggio e abete che unisce la fiamma vivace del legno duro alla pulizia dell'abete. Equilibrio perfetto per stufe e caldaie.", tags: ["ENplus A1", "Faggio", "Abete"] },
        { variant: "Abete Puro", desc: "Abete puro selezionato: il top di gamma. Colore chiaro, profumo naturale e cenere ridotta al minimo.", tags: ["ENplus A1", "Abete puro", "Top di gamma"] },
      ],
    },
    manifesto: {
      label: "Il nostro manifesto",
      title: "Esperienza che si sente ad ogni fiamma",
      founder: "Esperti di pellet · Filiera e produzione",
      chapters: [
        { title: "Anni nel mondo del pellet", body: "Non siamo intermediari improvvisati. Viviamo il settore del pellet da anni, conoscendo ogni passaggio della filiera: dalla materia prima alla combustione finale." },
        { title: "Conosciamo la produzione", body: "Padroneggiamo i processi di produzione del pellet e ogni fase della lavorazione, dalla materia prima alla pressatura. Una competenza tecnica che ci permette di selezionare solo prodotti realmente all'altezza." },
        { title: "Selezione, non compromesso", body: "Ogni marchio che distribuiamo è scelto per resa calorica, basso residuo di cenere e costanza nel tempo. La fiducia dei rivenditori si costruisce sulla qualità." },
      ],
    },
    audiences: {
      label: "A chi forniamo",
      titleA: "Un partner,", titleB: "ogni canale del mercato",
      intro: "Anni di attività e una conoscenza approfondita del mercato del pellet ci permettono di affiancare con reale professionalità ogni canale distributivo — dalla GDO ai rivenditori indipendenti, fino ai gruppi d'acquisto.",
      channels: [
        { tag: "Canale 01", title: "Rivenditori", desc: "Negozi, ferramenta e rivenditori di combustibili. Forniture flessibili in sacchetti da 15 kg, big bag e sfuso, con continuità durante tutta la stagione." },
        { tag: "Canale 02", title: "GDO — Grande Distribuzione", desc: "Catene e insegne della Grande Distribuzione Organizzata. Pellet certificato ENplus A1 pronto per lo scaffale, con affidabilità, volumi programmati e continuità di fornitura." },
        { tag: "Canale 03", title: "Gruppi d'acquisto", desc: "Solo camion completi (full truck), per la massima efficienza logistica e un prezzo dedicato ai grandi volumi." },
      ],
    },
    gruppi: {
      label: "Per i gruppi d'acquisto",
      badge: "Solo camion completi",
      titleA: "Grandi volumi,", titleB: "prezzo dedicato",
      desc: "Serviamo i gruppi d'acquisto esclusivamente con carichi completi. Un modello semplice che abbatte i costi logistici e li trasferisce direttamente sul prezzo.",
      yes: "Camion completi (full truck) di pellet",
      no: "Bancali singoli di pellet sciolto",
      cta: "Richiedi offerta gruppo",
    },
    quote: {
      label: "Richiedi preventivo",
      titleA: "Parliamo del tuo ", titleB: "fabbisogno",
      subtitlePre: "Ogni richiesta viene valutata personalmente. Indicaci la ", subtitleStrong1: "località di destinazione", subtitleMid: " e il ", subtitleStrong2: "tipo di pellet", subtitlePost: ": ti ricontattiamo con un'offerta su misura.",
      whatsapp: "WhatsApp diretto", call: "Chiamaci", email: "Email",
      guaranteeTitle: "Garanzia ENplus A1", guaranteeDesc: "Tutti i nostri pellet sono certificati ENplus A1 — qualità garantita ad ogni fornitura.",
      tabs: { rivenditore: "Rivenditore", gdo: "GDO", gruppo: "Gruppo d'Acquisto" },
      fields: { nome: "Nome e cognome *", azienda: "Azienda / Ragione sociale *", aziendaGruppo: "Nome del gruppo / referente *", email: "Email *", telefono: "Telefono *", provincia: "Località di destinazione *", prodotto: "Tipo di pellet *", formato: "Formato *", fornitura: "Fornitura", quantita: "Quantità stimata", messaggio: "Messaggio (facoltativo)" },
      ph: { nome: "Mario Rossi", azienda: "Rossi Combustibili srl", aziendaGruppo: "Es. Gruppo acquisto Val Rossi", email: "info@azienda.it", telefono: "+39 ...", provincia: "Città / Provincia / CAP", prodottoSel: "Seleziona marchio…", formatoSel: "Seleziona formato…", quantitaG: "es. 1 camion / mese", quantitaR: "es. 10 bancali", messaggio: "Note, tempistiche, richieste particolari…" },
      prodotti: ["TUpellet — Conifera Spagnola", "Fuoco nel Fuoco Gold — Faggio & Abete", "Fuoco nel Fuoco Platin — Abete Puro", "Da definire / consiglio"],
      formati: ["Sacchetti 15 kg", "Big Bag 1 t", "Alla rinfusa (sfuso)"],
      fixedFornitura: "Camion completo (full truck)",
      privacyPre: "Ho letto l'", privacyLink: "informativa sulla privacy", privacyPost: " e acconsento al trattamento dei miei dati personali per la gestione della mia richiesta, ai sensi del Regolamento (UE) 2016/679 (GDPR) e del D.Lgs. 196/2003 e s.m.i. *",
      submit: "Invia richiesta", note: "Nessun prezzo online · Ogni preventivo è personalizzato",
      errRequired: "Compila i campi obbligatori, incluso destinazione e tipo di pellet.",
      errFormato: "Seleziona il formato desiderato.",
      errPrivacy: "Per inviare la richiesta devi accettare l'informativa sulla privacy.",
      ok: "Richiesta inviata! Ti ricontattiamo al più presto con un preventivo dedicato.",
      errSend: "Errore nell'invio. Riprova o scrivici su WhatsApp.",
    },
    footer: {
      tagline: "Importazione e distribuzione all'ingrosso di pellet certificato in tutta Italia. Per GDO, rivenditori e gruppi d'acquisto.",
      cert: "Pellet certificato ENplus A1",
      contatti: "Contatti", marchiLabel: "Marchi",
      copyright: "PIESSETI Srl · PST Pellet è un marchio di PIESSETI Srl",
      privacy: "Privacy Policy", cookie: "Cookie Policy",
    },
    cookie: {
      pre: "Utilizziamo cookie tecnici necessari al funzionamento del sito e, previo consenso, cookie analitici per migliorare l'esperienza di navigazione. Puoi accettare o rifiutare i cookie non essenziali. Maggiori dettagli nella ",
      cookieLink: "Cookie Policy", mid: " e nella ", privacyLink: "Privacy Policy",
      accept: "Accetta", reject: "Rifiuta",
    },
  },

  en: {
    nav: { prodotti: "Products", marchi: "Brands", esperienza: "Experience", canali: "Channels", gruppi: "Buying Groups", cta: "Request a Quote" },
    hero: {
      label: "B2B Importer & Distributor",
      lines: ["SALE &", "DISTRIBUTION", "OF WOOD PELLETS"],
      subtitle: "Supply of certified wood pellets to retailers, large-scale retail (GDO) and buying groups throughout Italy. Bags, big bags, bulk and full truckloads — straight from production. Ideal pellets for stoves, fireplaces and pellet boilers.",
      cta: "Request a Quote",
      badge: "Certified quality",
      stats: [["15 kg", "Palletised bags"], ["1 t", "Big Bag"], ["Bulk", "Loose delivery"], ["Full truck", "Full truckloads"]],
    },
    marquee: ["TUpellet — Spanish Conifer", "Fuoco nel Fuoco Gold — Beech & Fir", "Fuoco nel Fuoco Platin — Pure Fir"],
    products: {
      label: "Supply formats",
      titleA: "How we ", titleB: "deliver",
      intro: "Every format is designed for a specific channel: from the local retailer to the large buying group.",
      cards: [
        { tag: "Retailers", title: "15 kg Bags", desc: "Sealed 15 kg bags on pallets, ready for retail distribution. Dedicated pallet composition for each brand." },
        { tag: "Retailers", title: "Big Bag 1 t", desc: "One-tonne bulk bags, ideal for storage and fast handling with a forklift." },
        { tag: "Retailers", title: "Bulk", desc: "Loose pellets delivered by tanker, for those with silos and storage systems." },
        { tag: "Buying groups & Retail", title: "Full Truckloads", desc: "Full truckloads only. We do not supply single pallets of loose pellets: maximum logistics efficiency and a dedicated price for buying groups." },
      ],
    },
    brands: {
      label: "The brands we distribute",
      titleA: "Three brands.", titleB: "One single quality.",
      cert: "All our pellets are ENplus A1 certified",
      specLabels: ["bags / pallet", "pallets / truck", "truck weight"],
      items: [
        { variant: "Spanish Conifer", desc: "100% conifer pellets of Spanish origin. High calorific value and steady combustion, with a truly excellent value for money: the ideal choice for those seeking yield and convenience.", tags: ["ENplus A1", "Conifer", "Value"] },
        { variant: "Beech & Fir", desc: "A beech and fir blend combining the lively flame of hardwood with the cleanliness of fir. Perfectly balanced for stoves and boilers.", tags: ["ENplus A1", "Beech", "Fir"] },
        { variant: "Pure Fir", desc: "Selected pure fir: the top of the range. Light colour, natural scent and ash reduced to a minimum.", tags: ["ENplus A1", "Pure fir", "Premium"] },
      ],
    },
    manifesto: {
      label: "Our manifesto",
      title: "Experience you feel in every flame",
      founder: "Pellet experts · Supply chain & production",
      chapters: [
        { title: "Years in the pellet world", body: "We are not improvised middlemen. We have lived the pellet sector for years, knowing every step of the supply chain: from raw material to final combustion." },
        { title: "We know production", body: "We master pellet production processes and every stage of manufacturing, from raw material to pressing. Technical expertise that lets us select only products that truly meet the mark." },
        { title: "Selection, no compromise", body: "Every brand we distribute is chosen for calorific yield, low ash residue and consistency over time. Retailers' trust is built on quality." },
      ],
    },
    audiences: {
      label: "Who we supply",
      titleA: "One partner,", titleB: "every market channel",
      intro: "Years of activity and a deep knowledge of the pellet market allow us to support every distribution channel with real professionalism — from large-scale retail (GDO) to independent retailers and buying groups.",
      channels: [
        { tag: "Channel 01", title: "Retailers", desc: "Shops, hardware stores and fuel retailers. Flexible supply in 15 kg bags, big bags and bulk, with continuity throughout the season." },
        { tag: "Channel 02", title: "GDO — Large-scale Retail", desc: "Chains and brands of large-scale organised retail. ENplus A1 certified pellets ready for the shelf, with reliability, scheduled volumes and continuity of supply." },
        { tag: "Channel 03", title: "Buying groups", desc: "Full truckloads only, for maximum logistics efficiency and a price dedicated to large volumes." },
      ],
    },
    gruppi: {
      label: "For buying groups",
      badge: "Full truckloads only",
      titleA: "Large volumes,", titleB: "dedicated price",
      desc: "We serve buying groups exclusively with full loads. A simple model that cuts logistics costs and passes them straight on to the price.",
      yes: "Full truckloads (full truck) of pellets",
      no: "Single pallets of loose pellets",
      cta: "Request group offer",
    },
    quote: {
      label: "Request a quote",
      titleA: "Let's talk about your ", titleB: "needs",
      subtitlePre: "Every request is reviewed personally. Tell us the ", subtitleStrong1: "delivery location", subtitleMid: " and the ", subtitleStrong2: "pellet type", subtitlePost: ": we'll get back to you with a tailored offer.",
      whatsapp: "Direct WhatsApp", call: "Call us", email: "Email",
      guaranteeTitle: "ENplus A1 Guarantee", guaranteeDesc: "All our pellets are ENplus A1 certified — quality guaranteed with every supply.",
      tabs: { rivenditore: "Retailer", gdo: "Retail (GDO)", gruppo: "Buying Group" },
      fields: { nome: "Full name *", azienda: "Company / Business name *", email: "Email *", telefono: "Phone *", provincia: "Delivery location *", prodotto: "Pellet type *", formato: "Format *", fornitura: "Supply", quantita: "Estimated quantity", messaggio: "Message (optional)" },
      ph: { nome: "John Smith", azienda: "Smith Fuels Ltd", email: "info@company.com", telefono: "+39 ...", provincia: "City / Province / Postcode", prodottoSel: "Select brand…", formatoSel: "Select format…", quantitaG: "e.g. 1 truck / month", quantitaR: "e.g. 10 pallets", messaggio: "Notes, timing, special requests…" },
      prodotti: ["TUpellet — Spanish Conifer", "Fuoco nel Fuoco Gold — Beech & Fir", "Fuoco nel Fuoco Platin — Pure Fir", "To be defined / advice"],
      formati: ["15 kg Bags", "Big Bag 1 t", "Bulk (loose)"],
      fixedFornitura: "Full truckload (full truck)",
      privacyPre: "I have read the ", privacyLink: "privacy policy", privacyPost: " and I consent to the processing of my personal data to handle my request, pursuant to Regulation (EU) 2016/679 (GDPR) and Italian Legislative Decree 196/2003. *",
      submit: "Send request", note: "No prices online · Every quote is personalised",
      errRequired: "Please fill in the required fields, including location and pellet type.",
      errFormato: "Please select the desired format.",
      errPrivacy: "To send the request you must accept the privacy policy.",
      ok: "Request sent! We'll get back to you shortly with a dedicated quote.",
      errSend: "Sending error. Please try again or contact us on WhatsApp.",
    },
    footer: {
      tagline: "Import and wholesale distribution of certified wood pellets throughout Italy. For large-scale retail, retailers and buying groups.",
      cert: "ENplus A1 certified pellets",
      contatti: "Contacts", marchiLabel: "Brands",
      copyright: "PIESSETI Srl · PST Pellet is a brand of PIESSETI Srl",
      privacy: "Privacy Policy", cookie: "Cookie Policy",
    },
    cookie: {
      pre: "We use technical cookies necessary for the site to work and, with your consent, analytics cookies to improve your browsing experience. You can accept or reject non-essential cookies. More details in the ",
      cookieLink: "Cookie Policy", mid: " and in the ", privacyLink: "Privacy Policy",
      accept: "Accept", reject: "Reject",
    },
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("pst_lang") || "it");
  useEffect(() => {
    localStorage.setItem("pst_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
